(function () {
  function initFabricSwatchRoot(root) {
    if (!root || root.getAttribute('data-fabric-swatch-initialized') === 'true') return;

    var grid = root.querySelector('[data-fabric-swatch-grid]');
    if (!grid) return;

    var templates = Array.prototype.slice.call(
      root.querySelectorAll('template.fabric-swatch-card-template')
    );
    if (!templates.length) return;

    var loadMoreBtn = root.querySelector('[data-fabric-swatch-load-more]');
    var sentinel = root.querySelector('[data-fabric-swatch-scroll-sentinel]');
    var batchSize = Number(root.getAttribute('data-batch-size') || 12);
    var rootMargin = Number(root.getAttribute('data-root-margin') || 600);
    var isLoading = false;
    var observer = null;

    if (!isFinite(batchSize) || batchSize < 1) batchSize = 12;
    if (!isFinite(rootMargin) || rootMargin < 0) rootMargin = 600;

    function refreshLazyImages(scope) {
      if (!scope) return;
      if (window.lazySizes && typeof window.lazySizes.loader === 'object') {
        window.lazySizes.loader.checkElems(scope.querySelectorAll ? scope : [scope]);
      }
    }

    function updateControls() {
      var hasRemaining = templates.length > 0;

      if (loadMoreBtn) {
        loadMoreBtn.classList.toggle('d-none', !hasRemaining);
        loadMoreBtn.disabled = !hasRemaining;
      }

      if (sentinel) {
        sentinel.classList.toggle('d-none', !hasRemaining);
      }

      if (!hasRemaining && observer && sentinel) {
        observer.unobserve(sentinel);
      }
    }

    function appendBatch() {
      if (isLoading || !templates.length) {
        updateControls();
        return;
      }

      isLoading = true;
      var fragment = document.createDocumentFragment();
      var count = Math.min(batchSize, templates.length);

      for (var i = 0; i < count; i++) {
        var template = templates.shift();
        if (template && template.content) {
          fragment.appendChild(template.content.cloneNode(true));
        }
        if (template && template.parentNode) {
          template.parentNode.removeChild(template);
        }
      }

      grid.appendChild(fragment);
      refreshLazyImages(grid);
      isLoading = false;
      updateControls();
    }

    function ensureViewportFilled() {
      var guard = 0;
      while (
        templates.length &&
        document.documentElement.scrollHeight <= window.innerHeight + 120 &&
        guard < 4
      ) {
        appendBatch();
        guard++;
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', appendBatch);
    }

    if ('IntersectionObserver' in window && sentinel) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              appendBatch();
            }
          });
        },
        {
          root: null,
          rootMargin: '0px 0px ' + rootMargin + 'px 0px',
          threshold: 0.01
        }
      );
      observer.observe(sentinel);
    }

    root.setAttribute('data-fabric-swatch-initialized', 'true');
    updateControls();
    ensureViewportFilled();
    window.addEventListener('resize', ensureViewportFilled);
    window.addEventListener('load', ensureViewportFilled);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-fabric-swatch-root]');
    for (var i = 0; i < roots.length; i++) {
      initFabricSwatchRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-fabric-swatch-root]');
    if (root) initFabricSwatchRoot(root);
  });
})();
